var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  New OAuth2.0 User enroll form\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }